import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { ProfileService } from '../../features/profile/services/profile.service';
import { RegistrationApprovalModel } from '../../features/workshop/models/registration-approval.model';

@Injectable({
  providedIn: 'root',
})
export class RegistrationApprovalService {
  private cachedStatus: RegistrationApprovalModel | null = null;

  constructor(private profileService: ProfileService) {
    this.getRegistrationApprovalStatus();
  }

  getRegistrationApprovalStatus(): Observable<RegistrationApprovalModel> {
    if (this.cachedStatus) {
      return of(this.cachedStatus);
    }
    return this.profileService.getMyRegistrationApprovalStatus().pipe(
      tap((status) => {
        this.cachedStatus = status;
      })
    );
  }
}
